var render = function render(){var _vm=this,_c=_vm._self._c;return _c('featuredCollections',_vm._b({attrs:{"collections-data":_vm.collectionsData}},'featuredCollections',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }